















import Vue, { PropType } from 'vue';

export type optionsType = {
  value: number;
  text: string;
};

export default Vue.extend({
  name: 'GSelectMenu',
  props: {
    value: { type: Number as PropType<number>, default: null },
    name: { type: String as PropType<string>, required: true },
    options: { type: Array as PropType<optionsType[]>, required: true },
    placeholder: { type: String as PropType<string>, default: '選択してください' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => [] },
    isNotArrow: { type: Boolean as PropType<boolean>, default: false },
  },
  computed: {
    innerValue: {
      get(): number {
        return this.value;
      },
      set(val: number): void {
        this.$emit('input', val);
      },
    },
  },
});
